import NavigationBar from "../components/navigationBar";
import FooterView from "../components/footerView";
import ContactUsComponent from "../components/contact-us/contactUsComponent";


export default function ContactUs() {

    return (
        <div>
            <NavigationBar />
            <ContactUsComponent />
            <FooterView />
        </div>
    )
}
